// prettier-ignore
// Only stylesheets needed for the FIRST PAINT belong here - this module is
// eager, so anything imported becomes render-blocking CSS. A CSS
// side-effect import does NOT follow the lazy boundary of the code it
// styles, so maplibre's and @mantine/charts' stylesheets shipped up front
// even though both are lazy-loaded; they now live with their own chunks.
// @mantine/carousel's was removed outright - nothing imports the carousel.
import "@mantine/core/styles.css";
// prettier-ignore
// prettier-ignore

import {
  MantineProvider,
  colorsTuple,
  createTheme,
  v8CssVariablesResolver,
  virtualColor,
} from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import React from "react";
import "./CustomMantineProvider.css";

interface MantineProviderProps {
  children?: React.ReactNode;
}

const theme = createTheme({
  colors: {
    lightBrown: colorsTuple("#6a5147"),
    darkBrown: colorsTuple("#46362f"),
    appBrown: virtualColor({
      dark: "darkBrown",
      light: "lightBrown",
      name: "appBrown",
    }),
    lightCream: colorsTuple("#f4e1be"),
    darkCream: colorsTuple("#f4e1be"),
    appCream: virtualColor({
      dark: "darkCream",
      light: "lightCream",
      name: "appCream",
    }),
    loaderColor: virtualColor({
      dark: "lightCream",
      light: "lightBrown",
      name: "loaderColor",
    }),
  },
  autoContrast: true,
  fontFamily: "NationalPark-Regular, sans-serif",
});

const CustomMantineProvider = (props: MantineProviderProps) => {
  return (
    <MantineProvider
      theme={theme}
      defaultColorScheme="auto"
      cssVariablesResolver={v8CssVariablesResolver}
    >
      <Notifications />
      <ModalsProvider>{props.children}</ModalsProvider>
    </MantineProvider>
  );
};

export default CustomMantineProvider;
